export function objectsToChangePass() {
  const query = `{
    objectsToChangePass{
        id, name, type
    }
}`;

  return query;
}

export function changePass(values) {
  const mappedObjects = values.objects.map((item) => ({
    id: item.id,
    name: item.name,
    type: item.type,
  }));

  let emailCc = '';
  if (values.emailCc.length) {
    emailCc = values.emailCc.join(',');
  }

  const mutationQuery = `mutation{
    changePass(objects:${JSON.stringify(mappedObjects).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}, mailCc: "${emailCc}",type: "RESP")
    {fullName, email, password}
}`;
  return mutationQuery;
}
